import { render, staticRenderFns } from "./SectionJob.vue?vue&type=template&id=0f95088f&scoped=true"
import script from "./SectionJob.vue?vue&type=script&lang=js"
export * from "./SectionJob.vue?vue&type=script&lang=js"
import style1 from "./SectionJob.vue?vue&type=style&index=1&id=0f95088f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f95088f",
  null
  
)

export default component.exports